import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=4c6db190&scoped=true"
import script from "./dataDictionary.vue?vue&type=script&lang=js"
export * from "./dataDictionary.vue?vue&type=script&lang=js"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=4c6db190&prod&lang=less&scoped=true"
import style1 from "./dataDictionary.vue?vue&type=style&index=1&id=4c6db190&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6db190",
  null
  
)

export default component.exports